import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { theme } from '@frontend/theme';
import { ContentSwitcherButton } from './content-switcher-button';

export type ContentSwitcherOption = 'operatory' | 'provider';

type ContentSwitcherProps = {
  iconOnly?: boolean;
  selectedOption: ContentSwitcherOption;
  onOptionChange: (option: ContentSwitcherOption) => void;
};

export const ContentSwitcher = ({ iconOnly = false, selectedOption, onOptionChange }: ContentSwitcherProps) => {
  const { t } = useTranslation('schedule');
  const tokens = useTranslationTokens();

  return (
    <div css={contentSwitcherContainerStyles}>
      <ContentSwitcherButton
        label={t('Provider')}
        iconName='user'
        iconOnly={iconOnly}
        isSelected={selectedOption === 'provider'}
        onClick={() => onOptionChange('provider')}
      />
      <ContentSwitcherButton
        label={tokens.operatory}
        iconName='department'
        iconOnly={iconOnly}
        isSelected={selectedOption === 'operatory'}
        onClick={() => onOptionChange('operatory')}
        dataId='content-switcher-operatory-button'
      />
    </div>
  );
};

const contentSwitcherContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '6px',
  padding: theme.spacing(0.25),
  backgroundColor: theme.colors.neutral10,
});
